var _rect, _path, _g, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustration3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 133,
    viewBox: "0 0 516 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 282.611,
    height: 184.434,
    rx: 20,
    transform: "matrix(0.95882 0.284015 -0.707107 0.707107 238.027 0.408264)",
    fill: "#183153"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M451.714 240.408C449.596 239.781 446.612 240.539 445.05 242.101L432.018 255.133C430.456 256.695 427.472 257.453 425.354 256.826L402.119 249.943C400.001 249.316 399.55 247.541 401.112 245.979L414.145 232.946C415.707 231.384 415.256 229.609 413.138 228.982L394.23 223.381C392.112 222.753 391.661 220.978 393.223 219.416L410.358 202.281C411.92 200.719 414.904 199.961 417.022 200.589L435.93 206.19C438.048 206.817 441.032 206.059 442.594 204.497L456.538 190.553C458.1 188.991 461.083 188.233 463.202 188.861L486.436 195.743C488.555 196.371 489.005 198.146 487.443 199.708L473.499 213.652C471.937 215.214 472.388 216.989 474.506 217.616L492.178 222.851C494.296 223.478 494.747 225.253 493.185 226.815L476.049 243.951C474.487 245.513 471.504 246.27 469.386 245.643L451.714 240.408Z",
    fill: "#1975FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_20_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.545 96.1387L370.402 122.567L362.62 120.262L405.763 93.8335L413.545 96.1387Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.715 116.165L404.981 108.443L410.835 102.589L426.734 116.226L422.353 120.607L415.715 116.165ZM397.825 115.599L415.715 116.165L422.353 120.607L421.645 121.315L391.971 121.453L397.825 115.599Z",
    fill: "white",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.744 95.735L364.487 96.4482L370.341 90.5937L340.668 90.7319L336.287 95.1132L346.744 95.735ZM357.331 103.604L346.744 95.735L336.287 95.1132L335.579 95.821L351.477 109.458L357.331 103.604Z",
    fill: "white",
    fillOpacity: 0.25
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4395 117.085C32.8102 116.603 30.5315 117.169 29.3498 118.351L22.3959 125.305C21.2142 126.487 21.577 127.836 23.2063 128.319L31.0242 130.634C32.6535 131.117 34.9322 130.55 36.1139 129.369L43.0678 122.415C44.2495 121.233 43.8867 119.884 42.2574 119.401L34.4395 117.085Z",
    fill: "#183153"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1651 118.293C22.6261 117.739 16.0625 119.784 12.3946 123.452L7.74083 128.106C7.00227 128.844 7.22906 129.687 8.24737 129.989L35.8311 138.16C36.8494 138.461 38.2736 138.107 39.0122 137.369L43.6659 132.715C47.1392 129.242 46.9568 125.372 43.6486 123.077L34.3447 132.381C33.5175 133.208 31.9223 133.604 30.7818 133.267L19.2763 129.859C18.1358 129.521 17.8818 128.576 18.709 127.749L28.1651 118.293Z",
    fill: "#183153"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78153 130.866C3.22467 130.423 4.07921 130.211 4.6902 130.392L37.1416 140.004C37.7526 140.185 37.8887 140.691 37.4455 141.134L35.4663 143.113C35.0232 143.556 34.1686 143.769 33.5577 143.588L1.10627 133.975C0.495274 133.794 0.359203 133.289 0.802341 132.845L2.78153 130.866Z",
    fill: "#183153"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_20_4",
    x: 320.579,
    y: 75.5938,
    width: 121.155,
    height: 61.9735,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur_20_4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration3);
export default __webpack_public_path__ + "static/media/Illustration3.b0fc4f5733a532237acd77bd1cee69a4.svg";
export { ForwardRef as ReactComponent };